import HeroComponent from "./HeroComponent";

const HeroSection = ({ homeRef, id }: any) => {
  return <HeroComponent homeRef={homeRef} id={id} />;
};

export default HeroSection;
